/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Preset_Name_LabelInputs */

const en_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset Name`)
};

const fr_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du preset`)
};

const de_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreingestellter Name`)
};

const it_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome predefinito`)
};

const ru_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название предустановки`)
};

const es_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del preajuste`)
};

const zh_cn2_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设名称`)
};

const ja_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセット名`)
};

const hi_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट नाम`)
};

const pt_pt2_styles_preset_name_label = /** @type {(inputs: Styles_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome predefinido`)
};

/**
* | output |
* | --- |
* | "Preset Name" |
*
* @param {Styles_Preset_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_preset_name_label = /** @type {((inputs?: Styles_Preset_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Preset_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_preset_name_label(inputs)
	if (locale === "de") return de_styles_preset_name_label(inputs)
	if (locale === "it") return it_styles_preset_name_label(inputs)
	if (locale === "ru") return ru_styles_preset_name_label(inputs)
	if (locale === "es") return es_styles_preset_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_preset_name_label(inputs)
	if (locale === "ja") return ja_styles_preset_name_label(inputs)
	if (locale === "hi") return hi_styles_preset_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_preset_name_label(inputs)
	return en_styles_preset_name_label(inputs)
});